module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "aboutAuthorPage"
  }, [_c('a', {
    attrs: {
      "id": "title14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JACQUELINE BAIRD")])]), _vm._v(" began writing as a hobby when her family objected to the smell of her oil painting, and she immediately became hooked on romance. She loves traveling and worked her way around the world from Europe to the Americas and Australia, returning to England to marry her teenage sweetheart. She lives in Northumbria, the county of her birth, and has two grown sons.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d99a72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459251816_ata01.vue
// module id = 63
// module chunks = 0